// src/services/itemDeliveryService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getStationUpdate = async () => {
  const event_id = localStorage?.getItem('event_id')
  return await axios.get(`${API_URL}/stationupdate/byevent/${event_id}`);
};

const getStationUpdateById = async (id) => {
  return await axios.get(`${API_URL}/stationupdate/${id}`);
};

const createStationUpdate = async (data) => {
  return await axios.post(`${API_URL}/stationupdate/`, data);
};

const updateStationUpdate = async (id, data) => {
  return await axios.put(`${API_URL}/stationupdate/${id}`, data);
};

const deleteStationUpdate = async (id) => {
  return await axios.delete(`${API_URL}/stationupdate/${id}`);
};

export default {
  getStationUpdate,
  getStationUpdateById,
  createStationUpdate,
  updateStationUpdate,
  deleteStationUpdate,
};
